<template>
  <div class="recaptcha-container">
    <h3>Verification</h3>
    <p>Please verify before proceeding to access page data.</p>
    <vue-recaptcha
      ref="recaptcha"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      :sitekey="siteKey"
      :loadRecaptchaScript="true">
    </vue-recaptcha>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    VueRecaptcha,
  },

  data() {
    return {
      siteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY
    };
  },

  methods: {
    back() {
      if (window.history.length === 0) {
        this.$router.push("/dashboard")
      } else {
        this.$router.back();
      }
    },

    onCaptchaVerified() {
      this.$emit('verified')
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    }
  }
};
</script>

<style scoped>
.recaptcha-container {
  background-color: #fff;
  border-radius: 8px;
  height: 300px;
  width: 600px;
  margin: 0 auto 200px;
  padding: 50px;
}

h3 {
  font-weight: 600;
  text-transform: unset;
  margin-top: 0;
}

.recaptcha-container > div {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
